import { Link } from "react-router-dom";
import { Truck, Menu, X } from "lucide-react";
import { useState } from "react";

export default function Header() {
  const [open, setOpen] = useState(false);
  const nav = [
    { label: "Services", href: "#services" },
    { label: "Why Adtrax", href: "#why" },
    { label: "Process", href: "#fleet" },
    { label: "Sign Up", href: "#quote" },
    { label: "Contact", href: "#contact" },
  ];
  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-white/80 backdrop-blur-xl border-b border-black/5">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <div className="w-8 h-8 bg-black flex items-center justify-center">
            <Truck size={18} className="text-[#FF4500]" strokeWidth={2} />
          </div>
          <span className="font-display font-bold text-lg tracking-tight">ADTRAX</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {nav.map((n) => (
            <a key={n.href} href={n.href} className="text-sm font-medium hover:text-[#FF4500] transition-colors" data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}>
              {n.label}
            </a>
          ))}
          <Link to="/track" className="font-mono-label text-xs px-3 py-2 border border-black hover:bg-black hover:text-white sharp-btn" data-testid="nav-track-link">
            TRACK LOAD
          </Link>
        </nav>

        <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Toggle menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-black/5 bg-white">
          <div className="px-6 py-4 flex flex-col gap-3">
            {nav.map((n) => (
              <a key={n.href} href={n.href} onClick={() => setOpen(false)} className="text-sm py-1" data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}>
                {n.label}
              </a>
            ))}
            <Link to="/track" onClick={() => setOpen(false)} className="font-mono-label text-xs py-2 border border-black text-center" data-testid="mobile-nav-track">
              TRACK LOAD
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
